import React from 'react';
import { Pressable } from 'react-native';
import colors from './colors';

export function getSvgProps(focused: Boolean) {
  return focused ? { fill: colors.primary.carnation } : null;
}

export function getTabBarComponent(labelName?: string) {
  return (props: any) => <Pressable testID={`tab_${labelName}`} {...props} />;
}
